module.exports = __webpack_public_path__ + "img/renata_cavion.ced50789.jpg";